/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

/**
 * Deliberately general, not Meeting- or Portfolio-specific: the values are exactly what `portfolio_task_questions.type` already stores, so Portfolio can adopt this enum later without a data migration.
 */
export type QuestionType = typeof QuestionType[keyof typeof QuestionType];


export const QuestionType = {
  single_line: 'single_line',
  multi_line: 'multi_line',
  radio: 'radio',
} as const;
